import Model from '@/lib/data/Model';

class PolicyInsured extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'insured_name' },
        { name: 'record_state', type: 'int', defaultValue: 1 },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get isActive() {
        return this.record_state == 1;
    }

    api = [
        {
            name: 'savePolicyXInsured',
            url: '/policy/insured/save',
            params: ['policy_id', 'policy_insured_id'],
        },
        {
            name: 'remove',
            url: '/policy/insured/delete',
            params: ['policy_id', 'policy_insured_id'],
        },
    ];
}

export default PolicyInsured;
